// Catering (backend migration 131): the accent, labels and small rules every
// admin screen shares. The rules themselves live on the backend in
// utils/catering.js; these only mirror what the screens show.

// The catering accent: RushMyFood red on a soft red tint, the same in every
// app (it was purple until 2026-10-16). Catering only.
export const CATERING = {
  accent: '#CC0000',
  soft: '#FFF1EE',
  border: '#FFE2DA'
}

// How catering orders are delivered. `vendor` is the restaurant's own wording
// (its Catering page); `admin` is how the super admin's list names it.
export const CATERING_DELIVERY_MODES = [
  {
    value: 'REGULAR',
    vendor: 'Same as my regular orders',
    admin: 'Same as regular orders',
    desc: 'Catering is delivered the way your regular orders are, by whoever delivers at that time.'
  },
  {
    value: 'RUSHMYFOOD',
    vendor: 'RushMyFood drivers',
    admin: 'RushMyFood drivers',
    desc: 'Our drivers deliver every catering order.'
  },
  {
    value: 'SELF',
    vendor: 'My own drivers',
    admin: "Restaurant's own drivers",
    desc: 'Your drivers deliver every catering order, at your catering delivery fees.'
  },
  {
    value: 'PICKUP_ONLY',
    vendor: 'Pickup only',
    admin: 'Pickup only',
    desc: 'Customers pick up their catering order. No delivery.'
  }
]

export const deliveryModeLabel = (mode, who = 'vendor') => {
  const m = CATERING_DELIVERY_MODES.find(x => x.value === mode)
  return m ? m[who] : mode || ''
}

/** "24 hours", "2 days", "90 minutes" — the same wording as the backend. */
export const describeLead = minutes => {
  const m = Math.max(0, Math.round(Number(minutes) || 0))
  if (m >= 2880 && m % 1440 === 0) return `${m / 1440} days`
  if (m >= 120 && m % 60 === 0) return `${m / 60} hours`
  if (m === 60) return '1 hour'
  return `${m} minutes`
}

/** The notice line customers see: "Order 24 hours ahead". */
export const noticeLine = minutes => `Order ${describeLead(minutes)} ahead`

const titleKey = title => String(title || '').trim().toLowerCase()

/** Lower-cased titles of the catering categories in a categories list. */
export const cateringTitles = categories =>
  new Set((categories || []).filter(c => c && c.isCatering).map(c => titleKey(c.title)).filter(Boolean))

/**
 * Is this item catering? Items carry their categories as a comma-separated
 * name; any one of them being a catering category makes it a catering item.
 */
export const isCateringItem = (item, titles) =>
  String(item?.categoryName || '')
    .split(',')
    .some(name => titles.has(titleKey(name)))
